export default __webpack_public_path__ + "static/media/store_google.a0f4b1cc.svg";